import { Text } from '@abyss/web/ui/Text';
import { t } from 'i18next';
import React from 'react';

import {
  ReverseCoverageTypesCodes,
  TypeaheadCoverageTypes,
} from '../../../Constants';
import { PSXIcon } from '../../../PSXIcon';
import { DonotDisturbIcon } from './DisplayCoverageTypes';
import {
  ContainerInactiveCoverage,
  CoverageIcon,
  CoverageType,
  InactiveCoverage,
} from './KeywordSearchDropdown.styled';

export const RenderMedicalCoverageLabels = (
  medicalSuppress,
  getCoverageType,
  coverageType,
  disableDDP,
  isDisplayingMedicalNotInYourBenefits,
  disabledMedicalCoverageLabel,
  dataTestIdForInEligibileCoverageType,
  notInYourBenefits,
  hideGreenTags
) => {
  if (medicalSuppress) {
    return (
      <>
        {(coverageType?.includes(ReverseCoverageTypesCodes.MEDICAL) &&
          getCoverageType?.includes(ReverseCoverageTypesCodes.MEDICAL) &&
          disableDDP) ||
          (isDisplayingMedicalNotInYourBenefits && (
            <Text
              css={InactiveCoverage}
              data-testid={dataTestIdForInEligibileCoverageType}
            >
              <div style={{ display: 'flex' }}>
                <ContainerInactiveCoverage>
                  <DonotDisturbIcon />
                  {t(TypeaheadCoverageTypes.MEDICAL)}
                </ContainerInactiveCoverage>
                {notInYourBenefits}
              </div>
            </Text>
          ))}
        {!hideGreenTags &&
          coverageType?.includes(ReverseCoverageTypesCodes.MEDICAL) &&
          getCoverageType?.includes(ReverseCoverageTypesCodes.MEDICAL) &&
          !disableDDP && (
            <Text css={CoverageType}>
              <div
                style={{
                  backgroundColor: '#F2F8E6',
                  display: isDisplayingMedicalNotInYourBenefits
                    ? 'none'
                    : 'flex',
                }}
              >
                <PSXIcon icon="Stethoscope" size={16} style={CoverageIcon} />
                {t(TypeaheadCoverageTypes.MEDICAL)}
              </div>
            </Text>
          )}
      </>
    );
  }
  return (
    <>
      {(coverageType?.includes(ReverseCoverageTypesCodes.MEDICAL) &&
        getCoverageType?.includes(ReverseCoverageTypesCodes.MEDICAL) &&
        disableDDP) ||
        isDisplayingMedicalNotInYourBenefits ||
        (disabledMedicalCoverageLabel && (
          <Text
            css={InactiveCoverage}
            data-testid={dataTestIdForInEligibileCoverageType}
          >
            <div style={{ display: 'flex' }}>
              <ContainerInactiveCoverage>
                <DonotDisturbIcon />
                {t(TypeaheadCoverageTypes.MEDICAL)}
              </ContainerInactiveCoverage>
              {notInYourBenefits}
            </div>
          </Text>
        ))}
      {!hideGreenTags &&
        coverageType?.includes(ReverseCoverageTypesCodes.MEDICAL) &&
        getCoverageType?.includes(ReverseCoverageTypesCodes.MEDICAL) &&
        !disableDDP && (
          <Text css={CoverageType}>
            <div
              style={{
                backgroundColor: '#F2F8E6',
                display:
                  isDisplayingMedicalNotInYourBenefits ||
                  disabledMedicalCoverageLabel
                    ? 'none'
                    : 'flex',
              }}
            >
              <PSXIcon icon="Stethoscope" size={16} style={CoverageIcon} />
              {t(TypeaheadCoverageTypes.MEDICAL)}
            </div>
          </Text>
        )}
    </>
  );
};
